import { useIdentityStore } from '../../lib/store';
import { parseToken } from '../../utils/token';

export const fetchFeatureFlags = async () => {
	const { areFeaturesFetched, experimentClient, isLoadingFeatures, token } = useIdentityStore.getState();

	if (areFeaturesFetched || isLoadingFeatures) {
		return;
	}

	const { userId, spoofingUserId, spoofingUserEmail } = parseToken(token);

	if (!userId) {
		throw new Error('No user data in JWT');
	}

	useIdentityStore.setState({ isLoadingFeatures: true });

	await experimentClient.fetch({
		user_id: userId,
		user_properties: {
			spoofing_user_id: spoofingUserId || '',
			spoofing_user_email: spoofingUserEmail || '',
		},
	});

	useIdentityStore.setState({
		areFeaturesFetched: true,
		isLoadingFeatures: false,
	});

	return experimentClient;
};
